import { isAIAdvisorAvailable } from '~/composables/ai-advisor-access'

/**
 * Gates the AI Advisor (OTTO) route behind the `feature_AIAdvisor` Split.io
 * flag OR a compareclub.com.au member email (CLUB-949). Client-only: the flag
 * lookup uses `crypto`/localStorage and rejects on SDK timeout, so default to
 * OFF (redirect) on any failure. Host-owned: the OTTO layer ships only the
 * `<OttoChat>` component, not the route or its gate.
 */
export default defineNuxtRouteMiddleware(async () => {
  if (import.meta.server) return
  try {
    const enabled = await isAIAdvisorAvailable()
    if (!enabled) return navigateTo('/dashboard/')
  } catch {
    return navigateTo('/dashboard/')
  }
})
